export default "__VITE_ASSET__AR0Q1Wx3__ 700w";